import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultCrmUsersDataSelector,
    accountSearchResultCrmUsersResultSelector,
} from '../../slices/account-search-result-crm-users.slice';

type Props = {
    accountId: number,
};

export const CrmEnabledUsersCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultCrmUsersDataSelector);
    const result = useSelector(accountSearchResultCrmUsersResultSelector);

    const count = useMemo(() => result?.data[accountId], [result, accountId]);

    if (isLoading || loadingError || !count) {
        return null;
    }

    return (
        <AccountLink
            accountId={accountId}
            place={PLACE}
            accountName={count.toString()}
            target="users-groups/crm-only"
        />
    );
};
